// Which demo organisation the fixtures adapter plays, so a reviewer can see the
// admin portal as a centre, as ONE individual practitioner, or as a centre
// Zooylo has suspended — without a backend. Demo mode only: the live adapter
// never reads this.
//
// Persisted per browser (a convenience, never state that matters), and a
// subscription lets the admin shell re-render every screen when it changes.

export type DemoVariant = "centre" | "individual" | "suspended";

export const DEMO_VARIANTS: readonly DemoVariant[] = ["centre", "individual", "suspended"];

const KEY = "zooylo.portal.demoOrg";
let current: DemoVariant | null = null;
const listeners = new Set<() => void>();

function read(): DemoVariant {
  try {
    const v = globalThis.localStorage?.getItem(KEY);
    if (v === "individual" || v === "suspended" || v === "centre") return v;
  } catch {
    // Private window / blocked storage: the default is fine.
  }
  return "centre";
}

export function getDemoVariant(): DemoVariant {
  if (current === null) current = read();
  return current;
}

export function setDemoVariant(v: DemoVariant): void {
  current = v;
  try {
    globalThis.localStorage?.setItem(KEY, v);
  } catch {
    // Not persisted; still applies for this page.
  }
  for (const l of listeners) l();
}

export function subscribeDemoVariant(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** Test seam. */
export function _resetDemoVariantForTest(v: DemoVariant = "centre"): void {
  current = v;
}
